export default __webpack_public_path__ + "static/media/lessThanIcon.643f95c0.svg";